import { BreakPointCondition, UI, useBreakpointIf, HStack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import { useNavigation } from '@react-navigation/native';
import { Box, Button } from 'native-base';
import { useCallback, useEffect } from 'react';
import { useRecoilState } from 'recoil';

import { FilterModal } from '../../../../../components/FilterModal';
import { getEmptySelections } from '../../../../../components/FilterModal/constants';
import { SignedInNavigationScreenNavigationProp } from '../../../../../routes/types';
import { orderHistoryFiltersAtom } from '../../../../../store/orderHistory/atom';

export const OrderHistoryFilters = () => {
  const { navigate } = useNavigation<SignedInNavigationScreenNavigationProp>();

  const [{ appliedFilters, availableFilters }, setProductsFiltersAtom] =
    useRecoilState(orderHistoryFiltersAtom);

  useEffect(() => {
    setProductsFiltersAtom({
      appliedFilters: [],
      selectedFilters: getEmptySelections(availableFilters),
      availableFilters,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [availableFilters]);

  return (
    <Button
      _text={{ textTransform: 'none' }}
      onPress={() => navigate('OrderHistoryFiltersModal')}
      paddingX={Spacing['inline.xxxs']}
      variant="secondary"
      {...(!appliedFilters.length && { rightIcon: <UI.Icon name="Funnel" size="xxxs" /> })}>
      <HStack alignItems="center" justifyContent="center" space={Spacing['inline.nano']}>
        <UI.Text variant="semibold" fontSize={Typography['fontsize.md']}>
          Filtrar
        </UI.Text>
        {!!appliedFilters.length && (
          <Box
            rounded="full"
            w="20px"
            h="20px"
            alignItems="center"
            justifyContent="center"
            bg={'brand.tertiary.light'}>
            <UI.Text variant="regular" fontSize={Typography['fontsize.xs']} color="neutral.white">
              {appliedFilters.length}
            </UI.Text>
          </Box>
        )}
      </HStack>
    </Button>
  );
};

export const OrderHistoryFiltersModal = () => {
  const navigation = useNavigation();
  const isMobile = useBreakpointIf(BreakPointCondition.EqualOrDown, 'sm');
  const isTablet = useBreakpointIf(BreakPointCondition.EqualOrDown, 'lg');

  const goBack = useCallback(() => {
    if (navigation.canGoBack()) {
      navigation.goBack();
    }
  }, [navigation]);

  const getSliderModalWidth = () => {
    if (isMobile) {
      return 1;
    }
    if (isTablet) {
      return 0.5;
    }
    return 0.3;
  };

  return (
    <FilterModal
      onClose={goBack}
      sliderModalWidth={getSliderModalWidth()}
      filterAtom={orderHistoryFiltersAtom}
    />
  );
};
